export default "__VITE_ASSET__X_3Zg1Tu__"